import React from "react"

import Layout from "../components/layout"
import PostCard from "../components/post-card"
import SEO from "../components/seo"
import { RiHome2Line } from "react-icons/ri"

// Components
import { Link, graphql } from "gatsby"

const months = ({ pageContext, data }) => {
  const { month, year } = pageContext

  const posts = data.allMarkdownRemark.edges
  .filter(edge => !!edge.node.frontmatter.date)
  .map(edge =>
    <PostCard key={edge.node.id} data={edge.node} />
  )

  return (
    <Layout className="blog-page">
      <SEO
      title={`${year}年${month}月 | アーカイブ`}
      description={`${year}年${month}月 | アーカイブ`}
      norobots={true}
      />
    <h1 className="taxonomy-header">{year}年{month}月の記事</h1>
      <div className="grids col-1 sm-2 lg-3">
          {posts}
      </div>

      <Link to={`/${year}/`} className="taxonomy-list">年別アーカイブ</Link>

      <div className="back-to-home">
      <Link to="/"><RiHome2Line />サイトトップへ</Link>
      </div>
      {/* <Link to="/cat/">カテゴリー一覧</Link> */}
      </Layout>
  )
}

export default months

export const pageQuery = graphql`
query($startMonth: Date, $endMonth: Date) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC },
      filter: {frontmatter: { date: { gte: $startMonth, lt: $endMonth }}}
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "YYYY/MM/DD")
            slug
            title
            year: date(formatString: "YYYY")
            month: date(formatString: "MM")
						featuredImage {
              publicURL
							childImageSharp {
								fluid(maxWidth: 540, maxHeight: 304, quality: 80) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  ...GatsbyImageSharpFluidLimitPresentationSize
                }
							}
						}
          }
        }
      }
    }
  }
`